import React from 'react'
import PropTypes from 'prop-types'

import { HighlightedText } from '../../../components'
import { chainDecorators, memoized } from '../../../utils/ReactUtils'
import LogoAnimation from './logo.json'

import styles from './styles'
import Lottie from 'lottie-react'

const decorators = [memoized]

function HomeCover(props) {
  const { baseline, description } = props

  function handleClickButton() {
    window.scrollTo(0, 900)
  }

  return (
    <div className="container">
      <div>
        <div className="content">
          <h1 className="baseline">
            <HighlightedText text={baseline} className="normal" />
          </h1>
          {description && <p className="description">{description}</p>}
        </div>
      </div>
      {/* <div className="pattern"><Lottie animationData={LogoAnimation}  /></div> */}
      <div className="right">
        <video autoPlay loop muted playsInline>
          <source src="/videos/hero_vid_2024.webm" type="video/webm" />
        </video>
      </div>
      <style jsx>{styles}</style>
    </div>
  )
}

HomeCover.propTypes = {
  baseline: PropTypes.string.isRequired,
  description: PropTypes.string,
}

HomeCover = chainDecorators(decorators, HomeCover)

export default HomeCover
